import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': '한국어',
  'smarthr-ui/ActionDialog/closeButtonLabel': '취소',
  'smarthr-ui/AppHeader/school': '스쿨',
  'smarthr-ui/AppHeader/help': '도움말',
  'smarthr-ui/AppHeader/userSettings': '개인 설정',
  'smarthr-ui/AppHeader/releaseNotes': '리리스 노트',
  'smarthr-ui/AppHeader/releaseNotesLoadError': '리리스노트의 불러오기를 실패했습니다.\n시간을 두고 다시 시도해 주세요.',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': '모든 리리스 노트를 보기',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': '앱',
  'smarthr-ui/AppHeader/MobileHeader/account': '어카운트',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': '메뉴를 열기',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': '메뉴를 닫기',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': '모든 앱',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': '관리메뉴',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': '최신 리리스 노트',
  'smarthr-ui/AppHeader/MobileHeader/back': '돌아가기',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': '열기',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': '닫기',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': '앱의 이름을 입력해 주세요.',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': '자주 사용하는 앱',
  'smarthr-ui/AppHeader/Launcher/allModeText': '모든 앱',
  'smarthr-ui/AppHeader/Launcher/listText': '앱 리스트',
  'smarthr-ui/AppHeader/Launcher/helpText': '자주 사용하는 앱이란',
  'smarthr-ui/AppHeader/Launcher/searchResultText': '검색결과',
  'smarthr-ui/AppHeader/Launcher/emptyText': '해당하는 앱을 발견할수 없습니다.',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': '표시순서',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': '선택중',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': '디폴트',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': '앱 이름의 오름차순',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': '앱 이름의 내림차순',
  'smarthr-ui/AppLauncher/showAllText': '모두 보기',
  'smarthr-ui/AppLauncher/triggerLabel': '앱',
  'smarthr-ui/Browser/notFoundDescription': '다른 조건을 시도해 보세요.',
  'smarthr-ui/Browser/notFoundTitle': '해당하는 항목이 없습니다.',
  'smarthr-ui/Button/loading': '처리중',
  'smarthr-ui/Calendar/currentYear': '현재 년도',
  'smarthr-ui/Calendar/nextMonth': '다음 달',
  'smarthr-ui/Calendar/previousMonth': '이전 달',
  'smarthr-ui/Calendar/selectYear': '년도 선택',
  'smarthr-ui/Combobox/addItemButtonLabel': '「{name}」를 추가',
  'smarthr-ui/Combobox/loadingText': '처리중',
  'smarthr-ui/Combobox/noResultsText': '일치하는 선택지가 없습니다.',
  'smarthr-ui/DropdownMenuButton/triggerActive': '후보를 닫기',
  'smarthr-ui/DropdownMenuButton/triggerInactive': '후보를 열기',
  'smarthr-ui/DropZone/selectButtonLabel': '파일을 선택',
  'smarthr-ui/FileViewer/rotateAlt': '좌회전',
  'smarthr-ui/FileViewer/scaleDownAlt': '축소',
  'smarthr-ui/FileViewer/scaleRateLabel': '확대율',
  'smarthr-ui/FileViewer/scaleUpAlt': '확대',
  'smarthr-ui/FileViewer/unsupportedFileText': '지원되지 않는 형식의 파일입니다.',
  'smarthr-ui/FilterDropdown/applyText': '적용',
  'smarthr-ui/FilterDropdown/cancelText': '취소',
  'smarthr-ui/FilterDropdown/resetText': '필터 조건을 해제',
  'smarthr-ui/FilterDropdown/status': '적용중',
  'smarthr-ui/FilterDropdown/triggerText': '필터',
  'smarthr-ui/FormDialog/closeButtonLabel': '취소',
  'smarthr-ui/InformationPanel/closeButtonLabel': '닫기',
  'smarthr-ui/InformationPanel/openButtonLabel': '열기',
  'smarthr-ui/InputFile/destroy': '삭제',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': '선택중',
  'smarthr-ui/Loader/alt': '처리중',
  'smarthr-ui/MessageDialog/closeButtonLabel': '닫기',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': '닫기',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': '다이얼로그 위치',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': '드래그 가능',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': '화살표 키를 눌러 상하좌우로 이동할 수 있습니다',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '위에서 {top}px, 왼쪽에서 {left}px',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': '를 삭제',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': '선택된 아이템',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': '닫기',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': '첫 페이지로',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': '마지막 페이지로',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': '다음으로',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': '이전으로',
  'smarthr-ui/Pagination/itemButtonLabel': '{page}페이지',
  'smarthr-ui/Pagination/navigationLabel': '페이지네이션',
  'smarthr-ui/RequiredLabel/text': '필수',
  'smarthr-ui/SearchInput/iconAlt': '검색',
  'smarthr-ui/SideMenu/navigationLabel': '사이트 메뉴',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': '지우기',
  'smarthr-ui/SortDropdown/applyText': '적용',
  'smarthr-ui/SortDropdown/ascLabel': '오름차순',
  'smarthr-ui/SortDropdown/cancelText': '취소',
  'smarthr-ui/SortDropdown/descLabel': '내림차순',
  'smarthr-ui/SortDropdown/sortFieldLabel': '정렬 항목',
  'smarthr-ui/SortDropdown/sortOrderLegend': '정렬 순서',
  'smarthr-ui/StepFormDialog/backButtonLabel': '돌아가기',
  'smarthr-ui/StepFormDialog/closeButtonLabel': '취소',
  'smarthr-ui/StepFormDialog/nextButtonLabel': '다음으로',
  'smarthr-ui/StepStatusIcon/closedAlt': '중단',
  'smarthr-ui/StepStatusIcon/completedAlt': '완료',
  'smarthr-ui/Textarea/availableLetters': '앞으로 {availableLetters}자',
  'smarthr-ui/Textarea/maxLettersExceeded': '{exceededLetters}자 초과',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': '최대 {maxLetters}자까지 입력할 수 있습니다',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': '다른 창으로 열기',
  'smarthr-ui/Th/sortDirectionAsc': '오름차순',
  'smarthr-ui/Th/sortDirectionDesc': '내림차순',
  'smarthr-ui/Th/sortDirectionNone': '정렬하지 않음',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': '모든 항목을 선택/해제',
  'smarthr-ui/ThCheckbox/checkColumnName': '선택',
} as const satisfies Record<keyof typeof ja, string>
